
const zendeskUrl = "https://static.zdassets.com/ekr/snippet.js?key=caf13a47-48de-4657-a99d-42ea29cb9e73";

export const initZendesk = () => {
    const script = document.createElement("script");
    Object.assign(script, { src: zendeskUrl, async: true, id: "ze-snippet" });
    document.body.appendChild(script);
}